import Quote from "./Quote";

export const ChannelQuote: React.FC = () => (
  <Quote caption="Effective Go" href="https://go.dev/doc/effective_go">
    Do not communicate by sharing memory; instead, share memory by
    communicating.
  </Quote>
);
